const negativeEvents = (xmlElement) => {
    const root = xmlElement.getElementsByTagName("cb:NegativeEvents");

    const NegativeEvents = Array.from(root).map(element => {
        const EventCode = element.attributes?.EventCode?.value ?? ''
        const EventCodeDesc = element.attributes?.EventCodeDesc?.value ?? ''
        const EventDetail = element.attributes?.EventDetail?.value ?? ''
        const EventDate = element.attributes?.EventDate?.value ?? ''
        const EventExpiryDate = element.attributes?.EventExpiryDate?.value ?? ''
        const ProviderTypeCode = element.attributes?.ProviderTypeCode?.value ?? ''
        const ProviderTypeCodeDesc = element.attributes?.ProviderTypeCodeDesc?.value ?? ''
        const ProviderCode = element.attributes?.ProviderCode?.value ?? ''
        const ProviderCodeDesc = element.attributes?.ProviderCodeDesc?.value ?? ''
        const BranchCode = element.attributes?.BranchCode?.value ?? ''
        const ReferenceDate = element.attributes?.ReferenceDate?.value ?? ''

        return { EventCode, EventCodeDesc, EventDetail, EventDate, EventExpiryDate, ProviderTypeCode, ProviderTypeCodeDesc, ProviderCode, ProviderCodeDesc, BranchCode, ReferenceDate };
    })

    return NegativeEvents;
}

export default negativeEvents;